module.exports = __webpack_public_path__ + "static/TheCakeryBakery-184356e7094d4046a31507a91bf924fe.gif";